import { useMemo } from "react";

import { FormikSelect, FormikTextInput } from "@sso/components/Formik";
import { UserKeys, roleOption, UserRole } from "@sso/constant";
import { GridItem } from "@sso/ui/FlexBox";

import FormikSelectWithBlur from "../Formik/FormikSelectWtihBlur";

interface UserFormFieldsProps {
  showRoleField?: boolean;
  showAdminRole?: boolean;
}

export const UserFormFields = ({ showAdminRole, showRoleField }: UserFormFieldsProps) => {
  const roles = useMemo(() => {
    const alteredRoles = roleOption.map(x => {
      return {
        key: x.key,
        value: x.key,
        label: x.label,
      };
    });

    return showAdminRole ? alteredRoles : alteredRoles.filter(item => item.key !== UserRole.ADMINISTRATOR);
  }, [showAdminRole]);

  return (
    <>
      <GridItem xs={12} sm={6}>
        <FormikTextInput name={UserKeys.FIRST_NAME} label="First Name" />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormikTextInput name={UserKeys.LAST_NAME} label="Last Name" />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormikTextInput name={UserKeys.USER_NAME} label="Username" />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormikTextInput name={UserKeys.EMAIL} label="Email" />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormikTextInput name={UserKeys.MOBILE} label="Mobile" />
      </GridItem>
      <GridItem xs={12} sm={6}>
        {showRoleField && <FormikSelectWithBlur name={UserKeys.ROLE_ID} label="Role" items={roles} />}
      </GridItem>
    </>
  );
};
